import Image from 'app/Components/Shared/Image/image';
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import ContentArea from '@episerver/spa-core/Components/ContentArea';

import Config from '../../../../../Config';
import EquipmentMine from '../EquipmentMine/EquipmentMine';
import { getImageProps } from 'app/utilities/ImageProps';
import fullSpecificationIcon from '../../icons/fullSpecificationIcon.svg';
import download from '../../icons/download.svg';
import authenticationProvider from '../../../../../utilities/authentication/authenticationProvider';
import Header from '../Header/Header';

function ListEquipments({ epiData, moreDetails, context, mineEquipments, openInstallationGuide, loginData }) {
  const [isLoading, setIsLoading] = useState(false);
  const [listEquipmentsCellcom, setListEquipmentsCellcom] = useState([]);
  const [listEquipmentsMine, setListEquipmentsMine] = useState([]);
  const [type, setType] = useState(null);

  useEffect(() => {
    if (
      loginData.isFullAuthenticated ||
      loginData.isOtpAuthenticated ||
      loginData.isOtpExtendedAuthenticated ||
      loginData.isSilentOtpAuthenticated
    ) {
      const myProductIds = mineEquipments
      .flatMap(item => item.equipments || [])
      .map(equip => equip.productId);

      if(mineEquipments.length >= 1){
        const filteredCellcom = epiData.routerList.filter(router =>
          !myProductIds.includes(router.nameProduct?.value || router.name)
        );
        const filteredMine = epiData.routerList.filter(router =>
          myProductIds.includes(router.nameProduct?.value || router.name)
        );
        if(myProductIds.length > 0){
          if(myProductIds.includes('NATAVT')){
            setType('noEquipment');
          }else if (filteredMine.length === 0) {
            setType('noInformationEpi');
          } else {
            setType('displayInformation');
            setListEquipmentsMine(filteredMine);
          };
          setListEquipmentsCellcom(filteredCellcom);
        }else{
          setType('noEquipment');
          setListEquipmentsCellcom(epiData.routerList);
        };
      }else if (mineEquipments.length === 0) {
          setType('noInformationBack');
          setListEquipmentsCellcom(epiData.routerList);
      };      
    }else {
      setListEquipmentsCellcom(epiData.routerList);
    };
  }, [loginData.isAuthenticateFinish, mineEquipments]);

  const equipments = listEquipmentsCellcom?.map((item, index) => {
    const nameProduct = item.nameProduct?.value;
    const nameModelProdact = item.nameModelProdact?.value;
    const displayName = nameModelProdact && nameModelProdact.trim() !== '' ? nameModelProdact : nameProduct;
    const imageProduct = getImageProps(item.imageProduct, context);
    
    return (
      <div key={index} className="product-card">
        {imageProduct.src && <Image src={imageProduct.src} alt={nameProduct} className="product-image" />}
        {displayName && <h3>{displayName}</h3>}
        <div className='links-wrapper'>
          {item.detailsList?.value &&              
            <button className='link-wrapper' onClick={() => moreDetails(item)}>
              <Image src={fullSpecificationIcon} alt='icon' />
              <div>מפרט מלא</div>
            </button>
          }
          {item.installationGuide?.value &&
            <button className='link-wrapper' onClick={() => openInstallationGuide(item)}>
              <Image src={download} alt='icon' />
              <div>מדריך התקנה</div>
            </button>
          }
        </div>
      </div>
    );
  });

  useEffect(() => {
    if (epiData?.imageTitle?.value?.url && epiData?.imageTitleMobile?.value?.url) {
      document.documentElement.style.setProperty('--support-topics-bg-web', `url(${Config.epiBaseUrl + epiData.imageTitle.value.url})`);
      document.documentElement.style.setProperty('--support-topics-bg-mobile', `url(${Config.epiBaseUrl + epiData.imageTitleMobile.value.url})`);
    };
  }, [epiData]);

  return (
    <div className='container-header-list-equipments'>
      <div className="image-background">
        <Header 
          listEquipmentsMine={listEquipmentsMine} 
          moreDetails={moreDetails} 
          openInstallationGuide={openInstallationGuide}
          type={type}
          isLoading={isLoading} 
          setIsLoading={setIsLoading}
        />
        {listEquipmentsCellcom.length >= 1 &&
          <div className='layout-wrapper-equipments'>
            <div className="product-list">
              <h2>{epiData?.titleProdactsCellcom}</h2>
              <div className='wrapper-products'>{equipments}</div>
            </div>
          </div>
        }
      </div>
    </div>
  );
}

const mapStateToProps = (state) => ({
  epiData: state.equipmentListPage.epiData,
  mineEquipments: state.equipmentListPage.mineEquipments,
  loginData: state.authentication.loginData,
});

export default connect(mapStateToProps)(ListEquipments);
